import { Directive, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { AbstractTextOperationDirective } from './abstact-text-operation.directive';

@Directive({
  selector: "input[trim], textarea[trim]",
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: TrimDirective, multi: true }]
})
export class TrimDirective extends AbstractTextOperationDirective {

  // Get a value of the removeSpace attribute if it was set.
  @Input() trim: string;

  protected processValue(value: string): string{
    return value?.trim();
  }

  protected eventValue(): string {
    return this.trim;
  }

}
